// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  KyberNetwork,
  Messages2,
  Calendar1,
  Kanban,
  Profile2User,
  Bill,
  UserSquare,
  ShoppingBag,
  People,
  LocationAdd,
  User,
  Paintbucket,
  Category2,
  Filter,
  MoneyAdd,
  // Coffee,
  Cake,
  ArrowDown,
  // Signpost,
  BackSquare,
  UserTick,
  Unlock,
  WatchStatus,
  TruckFast,
  Strongbox,
  ProfileTick,
  UserAdd,
  SmsNotification,
  MirroringScreen
} from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  application: KyberNetwork,
  chat: Messages2,
  bees: People,
  staff: ProfileTick,
  notification: People,
  city: LocationAdd,
  vendor: User,
  user: UserAdd,
  role: UserAdd,
  screens: MirroringScreen,
  sponsors: UserTick,
  inventory: WatchStatus,
  flavor: Cake,
  banners: SmsNotification,
  purchase: ShoppingBag,
  grn: TruckFast,
  quality_check: Strongbox,
  update_purchase: Unlock,
  Products: Paintbucket,
  orders: MoneyAdd,
  return: BackSquare,
  category: Category2,
  promocode: ArrowDown,
  filter: Filter,
  calendar: Calendar1,
  kanban: Kanban,
  customer: Profile2User,
  invoice: Bill,
  profile: UserSquare,
  ecommerce: ShoppingBag
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const qcmanagement: NavItemType = {
  id: 'group-purchase',
  title: <FormattedMessage id="Qc Management" />,
  icon: icons.purchase,
  menu_id: 1,
  type: 'group',
  children: [

    {
      id: 'grn',
      title: <FormattedMessage id="GRN" />,
      type: 'collapse',
      screen_id: 1,
      icon: icons.grn,
      children: [
        {
          id: 'grn-list',
          title: <FormattedMessage id="Updated GRN List" />,
          type: 'item',
          sub_screen_id: 1,
          url: '/apps/grn/grn-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-grn',
          title: <FormattedMessage id="Update GRN" />,
          type: 'item',
          sub_screen_id: 2,
          url: '/apps/grn/add-new-grn'
        }
      ]
    },
    {
      id: 'quality_check',
      title: <FormattedMessage id="Quality Check" />,
      type: 'collapse',
      screen_id: 2,
      icon: icons.quality_check,
      children: [
        {
          id: 'quality_check-list',
          title: <FormattedMessage id="Quality Check List" />,
          type: 'item',
          sub_screen_id: 3,
          url: '/apps/quality_check/quality_check-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-quality_check',
          title: <FormattedMessage id="Quality Check" />,
          type: 'item',
          sub_screen_id: 4,
          url: '/apps/quality_check/add-new-quality_check'
        },
        {
          id: 'add-new-stock',
          title: <FormattedMessage id="Stock Move" />,
          type: 'item',
          url: '/apps/quality_check/add-new-stock'
        }
      ]
    },
  ]
};

export default qcmanagement;
